import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ApiCommunicationService } from '../services/api-communication.service';
import { first } from 'rxjs/operators';
import { AttachedFile } from '../model/attached-file.model';
import { FileManagementService } from '../services/file-management.service';

@Component({
  selector: 'app-file-management',
  templateUrl: './file-management.component.html',
  styleUrls: ['./file-management.component.scss']
})
export class FileManagementComponent {

  constructor(private apiCommunicationService: ApiCommunicationService,
              private fileManagementService: FileManagementService) {
  }

  @ViewChild('uploadInput')
  private uploadInput: ElementRef;

  @Input()
  set rowKey(rowKey: string) {
    if (rowKey !== undefined) {
      this.internalRowKey = rowKey;
      this.getAttachedFiles();
    }
  }

  @Input()
  uploadFileTypes = '*';

  attachedFiles: AttachedFile[] = [];

  private isOpen = false;
  private internalRowKey;
  private uploadFileList: File[] = [];

  onSelectionChanged(data: any): void {
    this.isOpen = data.addedItems?.length > 0 && this.internalRowKey !== undefined;
    this.getAttachedFiles();
  }

  downloadFile(attachedFile: AttachedFile): void {
    this.fileManagementService.downloadFileAndServe(parseInt(attachedFile.k3vID, 10));
  }

  uploadFile(): void {
    if (this.internalRowKey !== undefined) {
      const input: HTMLInputElement = this.uploadInput.nativeElement;
      input.click();
    }
  }

  onUploadFileChange(event: any): void {
    this.uploadFileList = [];
    const input: HTMLInputElement = event.target;
    const fileExtRegExp: RegExp = /(?:\.([^.]+))?$/;
    if (input.files.length === 0) {
      return;
    }
    // tslint:disable-next-line:prefer-for-of
    for (let index = 0; index < input.files.length; index++) {
      const currentFileExt = fileExtRegExp
        .exec(input.files[index].name)[1]
        .toLowerCase();
      const isFormatValid = this.uploadFileTypes.includes(currentFileExt) || this.uploadFileTypes === '*';
      if (isFormatValid) {
        this.uploadFileList.push(input.files[index]);
      }
    }
    if (this.uploadFileList?.length === 0) {
      // show unsupported format selected message
      return;
    }
    const formData = new FormData();
    // Add data to be sent in this request
    this.uploadFileList.forEach((file, i) => {
      formData.append(
        'file',
        file
      );
    });
    this.fileManagementService.uploadFile(this.internalRowKey, formData).subscribe((data) => {
      this.uploadFileList = [];
      const inputElement: HTMLInputElement = this.uploadInput.nativeElement;
      inputElement.value = '';
      this.getAttachedFiles();
    });
  }

  private getAttachedFiles(): void {
    if (this.isOpen) {
      this.attachedFiles = [];
      this.apiCommunicationService.getAttachedFiles(this.internalRowKey).pipe(first()).subscribe(files => {
        if (files !== null && files !== undefined) {
          this.attachedFiles = files;
        }
      });
    }
  }
}
